// import external dependencies
import "jquery";

import "scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
import "scrollmagic/scrollmagic/uncompressed/plugins/jquery.ScrollMagic";
import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";

// Import everything from autoload
import "./autoload/_bootstrap.js"

import "select2/dist/js/select2.full";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import templateFlexible from "./routes/flexible";
import templateFaq from "./routes/faq";
import single from "./routes/single";
import singleService from "./routes/flexible";
import templateSedi from "./routes/flexible";
import Cookies from "js-cookie";

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
    home,
    templateFlexible,
    templateFaq,
    single,
    singleService,
    templateSedi,
});

// Load Events
$(document).ready(() => routes.loadEvents());
$(window).on("load", () => routes.loadLateEvents());
$(window).resize(() => routes.resizeEvents());



// WEBPACK FOOTER //
// ./scripts/main.js